import * as React from 'react';
import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import { useSelector } from 'react-redux';
import {
  EmptyReviewsTeaser,
  ManyReviewsTeaser,
  NewbuildingReviewsTeaser,
} from '../../components/NewbuildingReviewsTeaser';
import { getProductsData, getUser } from '../../selectors/analytics';
import { getBuilders, getDisplayName, getFullUrl, getNewbuildingId, getReviewsStat } from '../../selectors/newbuilding';
import { trackNewbuildingReviewsAnalytic } from '../../utils/analytics/reviewsAnalytics';
import { MasterReviewContainer } from '../MasterReviewContainer';

export const EMPTY_REVIEWS_COUNT = 0;

export const NewbuildingReviewsTeaserContainer: React.FC = () => {
  const reviewStat = useSelector(getReviewsStat);
  const fullUrl = useSelector(getFullUrl);
  const name = useSelector(getDisplayName);

  const user = useSelector(getUser);

  const builder = useSelector(getBuilders)[0] || null;
  const id = useSelector(getNewbuildingId);
  const products = [getProductsData(id, builder)];

  const page = {
    pageType: 'CardJK',
    siteType: 'desktop',
    extra: {
      type: 'review',
      rating: reviewStat?.rating,
      PageTypeJK: 'Featuring',
    },
  };

  const trackingReviewsTeaserView = React.useCallback(() => {
    trackNewbuildingReviewsAnalytic({
      action: 'Show_sopr',
      category: 'Card_JK',
      label: 'NewbuildingReviews',
      user,
      page,
      products,
    });
  }, []);

  const trackingShowReviewsLinkClick = React.useCallback(() => {
    trackNewbuildingReviewsAnalytic({
      action: 'Click_sopr',
      category: 'NewbuildingReviews',
      label: 'All_Reviews',
      user,
      page,
      products,
    });
  }, []);

  const trackingReadAllClick = React.useCallback(() => {
    trackNewbuildingReviewsAnalytic({
      action: 'Click_sopr',
      category: 'NewbuildingReviews',
      label: 'read_more',
      user,
      page,
      products,
    });
  }, []);

  if (!reviewStat || reviewStat.reviewsCount === EMPTY_REVIEWS_COUNT) {
    return <NewbuildingReviewsTeaser reviews={<EmptyReviewsTeaser name={name} fullUrl={fullUrl} />} />;
  }

  return (
    <ActionAfterViewed callback={trackingReviewsTeaserView}>
      <NewbuildingReviewsTeaser
        reviews={
          <ManyReviewsTeaser
            fullUrl={fullUrl}
            rating={reviewStat.rating}
            reviews={reviewStat.reviews}
            sections={reviewStat.sections}
            showReviewsLinkClick={trackingShowReviewsLinkClick}
            readReviewLinkClick={trackingReadAllClick}
            masterReview={<MasterReviewContainer />}
            title={reviewStat.title}
          />
        }
      />
    </ActionAfterViewed>
  );
};
